import { render, staticRenderFns } from "./LeagueList.vue?vue&type=template&id=0ecba598&scoped=true&"
import script from "./LeagueList.vue?vue&type=script&lang=js&"
export * from "./LeagueList.vue?vue&type=script&lang=js&"
import style0 from "./LeagueList.vue?vue&type=style&index=0&id=0ecba598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecba598",
  null
  
)

export default component.exports